<h2 mat-dialog-title>{{ 'cameras.addToGroupDialog.title' | t }}</h2>
<mat-dialog-content class="mat-typography">
  <div class="cameras-row">
    <div class="cameras-col">
      <form class="search-bar">
        <button
          mat-icon-button
          type="submit"
          [matTooltip]="'common.search' | t"
          class="sn-searchbar__search-button"
        >
          <sn-icon class="search">search</sn-icon>
        </button>
        <input [placeholder]="'common.search' | t" [formControl]="searchControl" />
        <button
          mat-icon-button
          [matTooltip]="'common.clearSearch' | t"
          class="sn-searchbar__clear-button"
          (click)="clear()"
        >
          <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
        </button>
      </form>
      <div class="camera-table">
        <sn-data-list #list reloadByQueryParams [fetchFn]="loadData">
          <sn-infinite-scroll>
            <sn-pull-to-refresh>
              <mat-table [dataSource]="tableData">
                <ng-container matColumnDef="name">
                  <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
                  <mat-cell *matCellDef="let camera">
                    {{ camera.name }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="location">
                  <mat-header-cell *matHeaderCellDef>{{ 'common.location' | t }}</mat-header-cell>
                  <mat-cell *matCellDef="let camera">
                    {{ camera.location ? camera.location.name : ('common.notSpecified' | t) }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="floor">
                  <mat-header-cell *matHeaderCellDef>{{ 'common.floor' | t }}</mat-header-cell>
                  <mat-cell *matCellDef="let camera">
                    {{ camera.floor ? camera.floor.name : ('common.notSpecified' | t) }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="owner">
                  <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
                  <mat-cell *matCellDef="let item">
                    <sn-object-owner [object]="item"></sn-object-owner>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row
                  matRipple
                  (click)="onSelected(camera)"
                  [ngClass]="{ active: isSelected(camera) }"
                  *matRowDef="let camera; columns: columns"
                >
                </mat-row>
              </mat-table>
              
              <div *ngIf="list.dataIsInited && !tableData.length" class="empty-state">
                <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
                  {{ 'common.noResultsMatchSearch' | t }}
                </sn-empty-state>
              </div>
            </sn-pull-to-refresh>
          </sn-infinite-scroll>
        </sn-data-list>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" mat-button mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button mat-button [mtBasicSpinner]="saving" color="success" (click)="submit()" cdkFocusInitial>
    {{ 'common.save' | t }}
  </button>
</mat-dialog-actions>
